import 'ol/ol.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import XYZ from 'ol/source/XYZ';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON.js';
import {bbox as bboxStrategy} from 'ol/loadingstrategy.js';

import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import Point from 'ol/geom/Point';
import {fromLonLat, toLonLat} from 'ol/proj';
import {Style, Fill, Stroke, Icon} from 'ol/style';
import Source from 'ol/source/ImageTile.js';
import KML from 'ol/format/KML.js';

let mapInstance = null;
const vectorSource = new VectorSource();
const vectorLayer = new VectorLayer({
  source: vectorSource,
  style: new Style({
    stroke: new Stroke({color: 'rgba(255,0,0,0.8)', width: 1}),
    fill: new Fill({color: 'rgba(255,204,0,0.4)'})
  })
});
const featureEventHandlers = new WeakMap();
let hoveredFeature = null;

function initMap({target = 'map', center = [10.0, 51.0], zoom = 6, localTileUrl = null} = {}) {
  const baseLayer = new TileLayer({
    source: new OSM()
  });
  
  const plzLayer = new TileLayer({
	  source: new Source({        url: localTileUrl}),
	  minZoom: 6,
	  maxZoom: 14
    });

  const layers = [baseLayer, plzLayer, vectorLayer];

  mapInstance = new Map({
    target,
    layers,
    view: new View({
      center: fromLonLat(center),
      zoom: zoom
    })
  });

  return mapInstance;
}

function clearEntities() {
  vectorSource.clear();
}

function addPushpin(lon, lat, options = {}) {
  const pt = new Feature({
    geometry: new Point([lon, lat])
  });
  if (options.icon) {
    pt.setStyle(new Style({
      image: new Icon({
        src: options.icon,
        scale: options.scale || 1
      })
    }));
  }
  if (options.metadata) {
    pt.Metadata = options.metadata;
  }
  vectorSource.addFeature(pt);
  return pt;
}

function addFeature(feature) {
  vectorSource.addFeature(feature);
  return feature;
}

function removeFeature(feature) {
  vectorSource.removeFeature(feature);
}

function addTileLayer({url = null, tileUrlFunction = null, maxZoom = 18, minZoom = 0} = {}) {
  if (!mapInstance) return;
  const sourceOptions = {
    tileSize: 256
  };
  if (tileUrlFunction) {
    sourceOptions.tileUrlFunction = function(tileCoord) {
      if (!tileCoord) return undefined;
      const [z, x, y] = tileCoord;
      return tileUrlFunction({zoom: z, x, x, y: y});
    };
  } else if (url) {
    sourceOptions.url = url;
  }
  const layer = new TileLayer({
    maxZoom,
    minZoom,
    source: new XYZ(sourceOptions)
  });
  mapInstance.addLayer(layer);
  return layer;
}

function getFeatures() {
  return vectorSource.getFeatures();
}

function fitToFeatures(padding = [50,50,50,50]) {
  const view = mapInstance.getView();
  const extent = vectorSource.getExtent();
  if (extent && !isNaN(extent[0])) {
    view.fit(extent, {padding});
  }
}

function readKML(kmlFile) {
	var kml = new KML();
	var features = kml.readFeatures(kmlFile, {dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'});
	for( i = 0; i < features.length; ++i ) {
		if( console ) console.log("adding a feature");
		features[i].setStyle(vectorLayer.getStyle());
		addFeature(features[i]);
	}
}

function readKMLFeature(geometry) {
	var kml = new KML();
	var feature = kml.readFeature(geometry, {dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'});
	if( feature ) {
		feature.setStyle(vectorLayer.getStyle());
		addFeature(feature);
	}
	return(feature);
}

function getCenter(feature) {
	var pt = new Polygon(feature.getGeometry()).getInteriorPoint();
	return(pt);
}

export default {
  initMap,
  clearEntities,
  addPushpin,
  addFeature,
  addTileLayer,
  removeFeature,
  getFeatures,  
  fitToFeatures,
  readKML,
  readKMLFeature,
  getCenter,
  fromLonLat,
  toLonLat,
  get instance() { return mapInstance; }
};
